import { useTranslation } from 'react-i18next';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import { CloudWatchEventRow } from './CloudWatchEventRow';
import type { SpanGroup } from './span-grouping';

/**
 * Request/Response-Paar mit gleicher SpanID (Spec 143 §5.3):
 * "→ Request … / ← Response, 1111 ms, 200" — visuell verbunden.
 */
export function SpanPair({ group }: { group: SpanGroup }) {
  const { t } = useTranslation('transactions');

  return (
    <div
      className="space-y-2 rounded-md border border-dashed border-border p-2"
      data-testid="span-pair"
    >
      <p className="text-xs text-muted-foreground">
        {t('trace.cloudwatch.span')}: <span className="break-all font-mono">{group.spanId}</span>
      </p>
      <div className="flex items-start gap-1">
        <ArrowRight className="mt-1 h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
        <div className="min-w-0 flex-1">
          <CloudWatchEventRow event={group.request} />
        </div>
      </div>
      {group.response && (
        <div className="flex items-start gap-1">
          <ArrowLeft className="mt-1 h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
          <div className="min-w-0 flex-1">
            <CloudWatchEventRow event={group.response} />
          </div>
        </div>
      )}
    </div>
  );
}
